/**
 * <s-reveal> — sets data-visible on itself the first time it scrolls into view,
 * so descendants can animate in with `group-data-visible/reveal:` utilities.
 * Reduced-motion users get the final state immediately via motion-safe utilities.
 *
 * Attributes:
 *   threshold — fraction of the element that must be visible (default 0.25)
 */
class SReveal extends HTMLElement {
  #observer;

  connectedCallback() {
    if (!('IntersectionObserver' in window)) {
      this.setAttribute('data-visible', '');
      return;
    }
    const threshold = Number(this.getAttribute('threshold')) || 0.25;
    this.#observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) {
        this.setAttribute('data-visible', '');
        this.#observer?.disconnect();
      }
    }, { threshold });
    this.#observer.observe(this);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }
}

if (!customElements.get('s-reveal')) customElements.define('s-reveal', SReveal);
